export enum WizardBarItemStatus {
    EMPTY = 'EMPTY',
    ACTUAL = 'ACTUAL',
    SUCCESS = 'SUCCESS',
    INCOMPLETE = 'INCOMPLETE',
}
